export const DEFAULTS = {
    typingDelayMs: 100,
    phrasePauseMs: 1000,
    eraseBeforeNext: true,
    eraseDelayMs: 60,
    loop: true,
    shuffle: false,
};
export class TypingPlaceholder {
    constructor(options = {}) {
        this.isRunning = false;
        this.timerId = null;
        this.index = 0;
        const { selector, element, phrases, ...rest } = options;
        const el = element ??
            (selector
                ? document.querySelector(selector)
                : null);
        if (!el)
            throw new Error("[TypingPlaceholder] Target element not found.");
        if (!("placeholder" in el))
            throw new Error("[TypingPlaceholder] Target must support placeholder.");
        this.el = el;
        this.opts = { ...DEFAULTS, ...rest };
        this.phrases = this.pickPhrases(phrases);
        if (this.opts.shuffle) {
            this.phrases = this.phrases.sort(() => Math.random() - 0.5);
        }
    }
    async start() {
        if (this.isRunning)
            return;
        this.isRunning = true;
        while (this.isRunning) {
            const phrase = this.phrases[this.index];
            if (!phrase)
                break;
            // 1) печатаем
            await this.typePhrase(phrase);
            if (!this.isRunning)
                break;
            // 2) ждём паузу после фразы
            await this.sleep(this.opts.phrasePauseMs);
            if (!this.isRunning)
                break;
            // 3) решаем, стирать ли фразу
            const lastCycleStep = (this.index + 1) % this.phrases.length === 0;
            const isLastAndNoLoop = lastCycleStep && !this.opts.loop;
            if (this.opts.eraseBeforeNext && !isLastAndNoLoop) {
                await this.eraseCurrent();
                if (!this.isRunning)
                    break;
            }
            else if (!this.opts.eraseBeforeNext && !isLastAndNoLoop) {
                // если не стираем — просто очищаем перед следующей
                this.setPlaceholder("");
            }
            // 4) переходим к следующей
            this.index = (this.index + 1) % this.phrases.length;
            // 5) если цикл не зациклен — завершаем
            if (isLastAndNoLoop) {
                this.stop();
            }
        }
    }
    stop() {
        this.isRunning = false;
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
    }
    setPhrases(next, resetIndex = true) {
        this.phrases = [...next];
        if (resetIndex)
            this.index = 0;
    }
    async typePhrase(phrase) {
        let current = this.el.getAttribute("placeholder") ?? "";
        if (current.length) {
            this.setPlaceholder("");
            current = "";
        }
        for (let i = 0; i < phrase.length && this.isRunning; i++) {
            current += phrase[i];
            this.setPlaceholder(current);
            await this.sleep(this.opts.typingDelayMs);
        }
    }
    async eraseCurrent() {
        let current = this.el.getAttribute("placeholder") ?? "";
        while (current.length && this.isRunning) {
            current = current.slice(0, -1);
            this.setPlaceholder(current);
            await this.sleep(this.opts.eraseDelayMs);
        }
    }
    sleep(ms) {
        return new Promise((resolve) => {
            const start = performance.now();
            const tick = (now) => {
                if (!this.isRunning) {
                    resolve();
                    return;
                }
                if (now - start >= ms) {
                    resolve();
                }
                else {
                    requestAnimationFrame(tick);
                }
            };
            requestAnimationFrame(tick);
        });
    }
    setPlaceholder(value) {
        this.el.setAttribute("placeholder", value);
    }
    pickPhrases(fromOptions) {
        if (fromOptions?.length)
            return [...fromOptions];
        const raw = this.el.getAttribute("data-phrases");
        if (raw) {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed) &&
                    parsed.every((p) => typeof p === "string")) {
                    return parsed;
                }
            }
            catch {
                // некорректный JSON → используем дефолт ниже
            }
        }
        return [];
    }
}
